import { useAuth } from '@/modules/auth/hooks/useAuth';
import { useUserImpersonation } from '@/contexts/UserImpersonationContext';

/**
 * Hook that returns the effective tenant ID considering impersonation mode
 * - During impersonation: returns the impersonated user's tenant_id
 * - Normal mode: returns the authenticated user's tenantId
 */
export function useEffectiveTenantId(): string | null {
  const { tenantId } = useAuth();
  const { impersonatedUser } = useUserImpersonation();

  // If in impersonation mode, use the impersonated user's tenant_id
  if (impersonatedUser?.tenant_id) {
    return impersonatedUser.tenant_id;
  }

  // Otherwise, use the normal tenant ID
  return tenantId;
}
